import { render, staticRenderFns } from "./PartBanner.vue?vue&type=template&id=0b2ca8ba&scoped=true&"
import script from "./PartBanner.vue?vue&type=script&lang=js&"
export * from "./PartBanner.vue?vue&type=script&lang=js&"
import style0 from "./PartBanner.vue?vue&type=style&index=0&id=0b2ca8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ca8ba",
  null
  
)

export default component.exports